/* eslint-disable max-len */

import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
  orgSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
  importDocument,
  datePicker,
} from 'app/components/global';
import editVendorManagerDialog from '../../vendors/dialog.editVendorManagerDialog';
import editCustomRiskControlDialog from '../dialog.editCustomRiskControlDialog';

import boardReviewAlertThresholdValueMessagesTpl from './messages/board-review-alert-threshold-value.messages.html';
import certificateOfInsuranceAlertThresholdValueMessagesTpl from './messages/coi-alert-threshold-value.messages.html';
import contractAutoRenewalAlertThresholdValueMessagesTpl from './messages/contract-auto-renewal-alert-threshold-value.messages.html';
import contractExpirationAlertThresholdValueMessagesTpl from './messages/contract-expiration-alert-threshold-value.messages.html';
import controlsReviewAlertThresholdValueMessagesTpl from './messages/controls-review-alert-threshold-value.messages.html';
import riskAssessmentAlertThresholdValueMessagesTpl from './messages/risk-assessment-alert-threshold-value.messages.html';
import riskCategoryWeightingMessagesTpl from './messages/risk-category.weighting.messages.html';
import systemAndOrganizationalControlsAlertThresholdValueMessagesTpl from './messages/soc-alert-threshold-value.messages.html';

import controller from './edit-settings-dialog.controller';
import template from './edit-settings-dialog.html';


class dialogService {
  getOptions($event, { settings }) {
    return {
      controller,
      controllerAs: 'settingsDialogVM',
      locals: {
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.settingsDialog', [
  alerts,
  confirmDialog,
  constants,
  importDocument,
  loaderService,
  orgDataService,
  orgSharedModelService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
  editVendorManagerDialog,
  editCustomRiskControlDialog,
  datePicker,
])
  .service('vmSettingsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('board-review-alert-threshold-value.messages.html', boardReviewAlertThresholdValueMessagesTpl);
    $templateCache.put('coi-alert-threshold-value.messages.html', certificateOfInsuranceAlertThresholdValueMessagesTpl);
    $templateCache.put('contract-auto-renewal-alert-threshold-value.messages.html', contractAutoRenewalAlertThresholdValueMessagesTpl);
    $templateCache.put('contract-expiration-alert-threshold-value.messages.html', contractExpirationAlertThresholdValueMessagesTpl);
    $templateCache.put('controls-review-alert-threshold-value.messages.html', controlsReviewAlertThresholdValueMessagesTpl);
    $templateCache.put('risk-assessment-alert-threshold-value.messages.html', riskAssessmentAlertThresholdValueMessagesTpl);
    $templateCache.put('risk-category.weighting.messages.html', riskCategoryWeightingMessagesTpl);
    $templateCache.put('soc-alert-threshold-value.messages.html', systemAndOrganizationalControlsAlertThresholdValueMessagesTpl);
  })
  .name;
